module.exports = __webpack_public_path__ + "img/knu2_gallery20.ecaa4d88.jpg";